import { cn } from '@/util/ui';

export const BUTTON_VARIANTS = {
  primary: cn(
    'tw-rounded-[5px]',
    'tw-text-cfo-blue-700 tw-border-cfo-blue-700 tw-bg-white'
  ),
  primary_light_blue: cn(
    'tw-rounded-[5px]',
    'tw-text-cfo-blue-600 tw-border-cfo-blue-600 tw-bg-white'
  ),
  secondary: cn(
    'tw-rounded-[5px]',
    'tw-text-white tw-border-cfo-blue-700 tw-bg-cfo-blue-700'
  ),
  inverse: cn(
    'tw-rounded-[5px]',
    'tw-text-cfo-black tw-border-cfo-grey-500 tw-bg-white'
  ),
  danger: cn(
    'tw-rounded-[5px]',
    'tw-text-cfo-red-400 tw-border-cfo-red-400 tw-bg-white'
  ),
  fille_light_blue: cn(
    'tw-rounded-[5px]',
    'tw-text-cfo-blue-600 tw-border-cfo-blue-100 tw-bg-cfo-blue-100'
  ),
  filled_danger: cn(
    'tw-rounded-[5px]',
    'tw-text-white tw-border-cfo-red-400 tw-bg-cfo-red-400'
  ),
  filled_inverse: cn(
    'tw-rounded-[5px]',
    'tw-text-cfo-black tw-border-cfo-grey-500 tw-bg-cfo-grey-100'
  ),
  style_unset: cn('tw-rounded-none', 'tw-text-cfo-black tw-border-none'),
  unstyled: cn(
    'tw-rounded-none tw-border-none tw-text-current tw-m-0',
    'tw-p-0'
  ),
};

export const BUTTON_SIZE = {
  xs: cn('tw-px-[10px] tw-py-[3px] tw-text-[12px]'),
  sm: cn('tw-px-[10px] tw-py-[3px] tw-text-[14px]'),
  md: cn('tw-px-[10px] tw-py-[6px] tw-text-[16px]'),
  lg: cn('tw-px-[46px] tw-py-[11px] tw-text-[14px]'),
};

export const BUTTON_WEIGHT = {
  normal: cn('tw-font-brandonTextRegular'),
  bold: cn('tw-font-brandonTextMedium'),
};

export const BUTTON_POSITION = {
  right: cn('tw-justify-end tw-text-right'),
  left: cn('tw-justify-start tw-text-left'),
  center: cn('tw-justify-center tw-text-center'),
  between: cn('tw-justify-between'),
};

export const getButtonStyleSettings = ({
  variant = BUTTON_VARIANTS.style_unset,
  weight = BUTTON_WEIGHT.normal,
  size = BUTTON_SIZE.sm,
  position = BUTTON_POSITION.center,
  isActive = false,
  activeStyles = '',
} = {}) => {
  const variantClass = isActive
    ? activeStyles
    : BUTTON_VARIANTS[variant] || BUTTON_VARIANTS.style_unset;

  return cn(
    variantClass,
    size && BUTTON_SIZE[size],
    weight && BUTTON_WEIGHT[weight],
    position && BUTTON_POSITION[position]
  );
};
